import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byteFormatter',
  standalone: false,
})
export class ByteFormatterPipe implements PipeTransform {
  transform(bytes: number): string {
    if (bytes <= 0) return '0 Bytes'; // Controllo per valori negativi o zero

    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let i = Math.floor(Math.log(bytes) / Math.log(1024)); // Trova l'indice dell'unità giusta

    // Dividi i bytes per 1024 elevato all'indice trovato
    let value = bytes / Math.pow(1024, i);

    // Per i Gigabytes torno un decimale altrimenti no
    if (sizes[i] === 'GB') {
      return `${value.toFixed(1)} ${sizes[i]}`;
    } else {
      return `${value.toFixed(0)} ${sizes[i]}`;
    }
  }
}
